import React from 'react';
import { pricingDto } from '@app/models/dtos';
import { Button } from '@anonymizePro/components/ui/button';
import environments from '@app/configs/environments';

interface PricingCardProps {
    pricing: pricingDto;
}

interface ResponseProps {
    authorizationUrl: string;
}

function PricingCard({ pricing }: PricingCardProps) {
    const variant = pricing.isPopular ? 'default' : 'secondary';
    const handleButton = async () => {
        const response = await fetch(environments.ANONYMIZE_PRO_BACKEND_URL + '/api/oauth/authorization?locale=en');
        if (response.ok) {
            const jsonResponse: ResponseProps = await response.json();
            window.open(jsonResponse.authorizationUrl);
        }
    };
    return (
        <div className="relative flex max-w-[300px] flex-col justify-between border p-6 text-start">
            {pricing.isPopular && <div className="anonymize-p5 absolute right-5 top-5 rounded-[32px] bg-pink-1 px-4 py-1 text-pink">Popular</div>}
            <div>
                <p className="anonymize-p3 mb-2 text-black-800">{pricing.title}</p>
                <p className="anonymize-h2 text-black-800">
                    {pricing.cost !== 'Free' && '€'}
                    {pricing.cost}
                </p>
                <p className="anonymize-p5 text-black-700">for {pricing.timeLimitation}</p>
                <p className="anonymize-p4 mb-6 mt-4 flex min-h-[84px] items-center pr-6 text-black-700">{pricing.description}</p>
                <p className="anonymize-h4 text-black-800">{pricing.pageNumber} Pages</p>
                {pricing.additionalCost !== 0 && <p className="anonymize-p5 mb-10 mt-1 text-black-700">Additional cost per page: €{pricing.additionalCost}</p>}
            </div>
            <Button onClick={handleButton} size="sm" variant={variant}>
                <span className="anonymize-p3">{pricing.buttonText}</span>
            </Button>
        </div>
    );
}

export default PricingCard;
